<template>
  <div class="chat-message" :class="{ own: isOwn }">
    <div class="bubble">
      <div v-if="hasFiles" class="files">
        <div v-for="f in message.files" :key="f.id || f.url" class="file-item">
          <template v-if="isImage(f)">
            <a :href="f.url" target="_blank" rel="noopener noreferrer" class="img-link">
              <img :src="f.url" class="img" :alt="f.name || 'imagem'">
            </a>
          </template>
          <template v-else>
            <a :href="f.url" target="_blank" rel="noopener noreferrer" class="file-link">
              <span class="ico">📎</span>
              <span class="name">{{ f.name || 'arquivo' }}</span>
              <span class="meta">{{ prettySize(f.size) }}</span>
            </a>
          </template>
        </div>
      </div>

      <div v-if="textToShow" class="content">{{ textToShow }}</div>
      <div class="time">{{ formatTime(message.timestamp) }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ChatMessage',
  props: ['message'],
  computed: {
    isOwn () {
      const userId = this.$store.state.auth.user.id
      return String(this.message.senderId) === String(userId)
    },
    hasFiles () {
      return this.message && Array.isArray(this.message.files) && this.message.files.length > 0
    },
    textToShow () {
      const txt = (this.message && this.message.content) ? String(this.message.content) : ''
      if (this.hasFiles && (txt === '[arquivo]' || txt === '[file]' || txt === '[anexo]')) return ''
      return txt
    }
  },
  methods: {
    formatTime (ts) {
      const d = new Date(ts)
      return d.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' })
    },
    isImage (f) {
      const m = (f && (f.mimetype || f.mimeType || f.mime)) ? String(f.mimetype || f.mimeType || f.mime) : ''
      return /^image\//.test(m)
    },
    prettySize (bytes) {
      const n = Number(bytes || 0)
      if (!n) return ''
      if (n < 1024) return n + ' B'
      if (n < 1024 * 1024) return (n / 1024).toFixed(1) + ' KB'
      return (n / (1024 * 1024)).toFixed(1) + ' MB'
    }
  }
}
</script>

<style scoped>
.chat-message { margin-bottom: 12px; display: flex; }
.chat-message.own { justify-content: flex-end; }

.bubble {
  max-width: 75%;
  padding: 8px 12px;
  border-radius: 12px;
  background: #f0f0f0;
}

.chat-message.own .bubble {
  background: linear-gradient(135deg, #9c27b0, #673ab7);
  color: #fff;
}

.content { margin-top: 6px; word-wrap: break-word; }
.time { font-size: 11px; margin-top: 6px; opacity: .7; text-align: right; }

.files { display: grid; gap: 8px; }
.img { width: 220px; max-width: 100%; border-radius: 10px; display: block; }
.file-link {
  display: flex; align-items: center; gap: 8px;
  padding: 10px; border-radius: 10px;
  background: rgba(255,255,255,.6);
  color: inherit; text-decoration: none;
}
.chat-message.own .file-link { background: rgba(255,255,255,.18); }
.name { flex: 1; min-width: 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; font-weight: 600; }
.meta { font-size: 12px; opacity: .75; }
</style>



// WEBPACK FOOTER //
// ChatMessage.vue?1244c0a7